<template>
  <v-responsive :aspect-ratio="16/7">
    <v-container fluid fill-height>
      <v-layout
        align-center
        justify-center
        fill-height
        row
        class="mt-5 pt-5"
        style="position: relative;"
      >
        <div class="carousel-container">
          <div class="swiper-container" ref="swiper">
            <div class="swiper-wrapper">
              <img
                :src="img.placeholder"
                v-for="(img,i) in images"
                :data-src="img.src"
                :data-index="i"
                :key="i"
                class="swiper-slide slide-h-auto home-slide lazy"
              />
            </div>
          </div>
          <!-- <v-img
            class="placeholder"
            v-show="isLoader"
            :src="require('../../assets/home-slider/placeholder.jpg')"
          ></v-img>-->
        </div>
        <home-search-form></home-search-form>
      </v-layout>
    </v-container>
  </v-responsive>
</template>

<script>
import _ from "lodash";
import Swiper from "swiper";
import HomeSearchForm from "../HomeSearchForm";

export default {
  name: "HomeSlider",
  // props: ["images"],
  components: {
    "home-search-form": HomeSearchForm
  },
  data: () => ({
    swiper: null,
    isLoader: false,
    images: [
      {
        src: require("../../assets/home-slider/1.jpg"),
        placeholder: require("../../assets/home-slider/placeholder-1.jpg")
      },
      {
        src: require("../../assets/home-slider/2.jpg"),
        placeholder: require("../../assets/home-slider/placeholder-2.jpg")
      },
      {
        src: require("../../assets/home-slider/3.jpg"),
        placeholder: require("../../assets/home-slider/placeholder-3.jpg")
      },
      {
        src: require("../../assets/home-slider/4.jpg"),
        placeholder: require("../../assets/home-slider/placeholder-3.jpg")
      }
    ]
  }),

  computed: {},

  methods: {
    loadSwiper: function() {
      this.swiper = new Swiper(this.$refs.swiper, {
        loop: true,
        slidesPerView: "auto",
        effect: "fade",
        speed: 2000,
        observer: true,

        observeSlideChildren: true,
        fadeEffect: {
          crossFade: true
        },
        autoplay: {
          delay: 20000,
          disableOnInteraction: false
        }
      });

      this.swiper.on("slideChange", () => {
        this.$forceUpdate();
        this.swiper.update();
      });
    },
    getImage(src) {
      let result = src;
      let img = new Image();
      img.src = src;
      img.onload = () => {};
    },
    updateDuplicate(dupl) {
      document.querySelectorAll(".swiper-slide-duplicate").forEach(item => {
        let index = item.dataset.index;
        item.src = this.images[index].src;
        item.classList.add("lazy-loaded");
      });
    }
  },

  mounted: function() {
    setTimeout(() => this.loadSwiper(), 280);
    document.querySelectorAll("img.lazy").forEach(item => {
      let image = item.dataset.src;
      let index = item.dataset.index;

      let img = new Image();
      img.src = image;
      img.onload = () => {
        item.src = image;
        item.classList.add("lazy-loaded");
        let images = _.cloneDeep(this.images);

        images[index].placeholder = image;
        this.images = images;
        setTimeout(() => this.updateDuplicate(), 50);
      };
    });
  }
};
</script>

<style lang="scss" scoped>
.carousel-container {
  position: absolute;
  left: 0;
  right: 0;
  height: 840px;
  top: 0;
}
.lazy {
  filter: blur(50px);
  &.lazy-loaded {
    filter: blur(0px);
    animation: blur 1s ease 0s;
    -webkit-animation: blur 1s ease 0s;
    -moz-animation: blur 1s ease 0s;
  }
}
.home-slide {
  // transition: 10s filter linear;
  // -webkit-transition: 10s -webkit-filter linear;
  // -moz-transition: 10s -moz-filter linear;
  // -ms-transition: 10s -ms-filter linear;
  // -o-transition: 10s -o-filter line;
}
@keyframes blur {
  from {
    -webkit-filter: blur(50px);
    -moz-filter: blur(50px);
    -o-filter: blur(50px);
    -ms-filter: blur(50px);
  }
  to {
    -webkit-filter: blur(0px);
    -moz-filter: blur(0px);
    -o-filter: blur(0px);
    -ms-filter: blur(0px);
  }
}
</style>